module.exports = __webpack_public_path__ + "img/tools_paytrend_livingwage.0b726921.png";